// How to use icons:
// MUI icon: add it in IconMappingMUI.js
// SVG icon: add it in IconMappingSVG.js

import descriptorToIconFromMUI from "./IconMappingMUI";
import descriptorToIconFromSVG from "./IconMappingSVG";

const iconMapping = {
  ...descriptorToIconFromSVG,
  ...descriptorToIconFromMUI,
};

export default iconMapping;
